import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: "expert-list",
  name: "专家咨询",
  icon: "专",
  group: "国学组件",
  description: "展示专家、排班、图文咨询和预约入口。",
  defaultProps: {
    "title": "专家咨询",
    "limit": 4
}
}
